export const TIPO =
{
    Alvara: "Alvara",
    Anuencia: "Anuencia",
    AutDemol: "AutDemol",
    AutERB: "AutERB",
    AutObrasInfra: "AutObrasInfra",
    AutRepGerais: "AutRepGerais",
    AutRepGeraisAcess: "AutRepGeraisAcess",
    CertDemol: "CertDemol",
    CertRegul: "CertRegul",
    CertLaudoVist: "CertLaudoVist",
    CertRegulInfra: "CertRegulInfra",
    CertUsoOcupSolo: "CertUsoOcupSolo",
    CertUsoOcupSoloDir: "CertUsoOcupSoloDir",
    DeclAtendTermoCompr: "DeclAtendTermoCompr",
    DeclConcObrasInfra: "DeclConcObrasInfra",
    DeclGLP: "DeclGLP",
    DeclInstERB: "DeclInstERB",
    DeclNumeroPorta: "DeclNumeroPorta",
    DeclRepGerais: "DeclRepGerais",
    DeclRepGeraisAcess: "DeclRepGeraisAcess",
    DirDrenagem: "DirDrenagem",
    GuiaPag: "GuiaPag",
    Habitese: "Habitese",
    TermoDemarc: "TermoDemarc",
    TermoDesmGleba: "TermoDesmGleba",
    TermoDesmLote: "TermoDesmLote",
    TermoRem: "TermoRem",
    TermoRemDesm: "TermoRemDesm",
    TermoVerObras: "TermoVerObras"
}

export const TIPONOME =
{
    Alvara: "Alvará de construção",
    Anuencia: "Anuência prévia",
    AutDemol: "Autorização para demolição",
    AutERB: "Autorização para instalação de Estação Rádio-Base",
    AutObrasInfra: "Autorização para obras de infraestrutura",
    AutRepGerais: "Autorização para reparos gerais",
    AutRepGeraisAcess: "Autorização para Reparos Gerais de Acessibilidade",
    CertDemol: "Certidão de demolição",
    CertRegul: "Certidão de regularização",
    CertLaudoVist: "Certidão de laudo de vistoria",
    CertRegulInfra: "Certidão de regularização para obras de infraestrutura",
    CertUsoOcupSolo: "Certidão de uso e ocupação do solo",
    CertUsoOcupSoloDir: "Certidão de uso e ocupação do solo e diretrizes",
    DeclAtendTermoCompr: "Atendimento a termo de compromisso",
    DeclConcObrasInfra: "Conclusão de obras de infraestrutura",
    DeclGLP: "Revenda de Gás Liquefeito de Petróleo",
    DeclInstERB: "Instalação de Estação Rádio-Base",
    DeclNumeroPorta: "Número de porta",
    DeclRepGerais: "Conclusão de reparos gerais",
    DeclRepGeraisAcess: "Conclusão de reparos gerais de acessibilidade",
    DirDrenagem: "Diretrizes de drenagem pluvial",
    Habitese: "Habite-se",
    TermoDemarc: "Termo de aprovação de Demarcação",
    TermoDesmGleba: "Termo de aprovação de desmembramento de gleba",
    TermoDesmLote: "Termo de aprovação de desmembramento de lote",
    TermoRem: "Termo de aprovação de remembramento",
    TermoRemDesm: "Termo de aprovação de desmembramento com remembramento",
    TermoVerObras: "Termo de verificação de obras"
}

export const SUBTIPO =
{
    Uniresidencial: "Uniresidencial",
    MultiresidencialAte4Pav: "MultiresidencialAte4Pav",
    MultiresidencialAcima4Pav: "MultiresidencialAcima4Pav",
    NaoResidencial: "NaoResidencial",
    Loteamento: "Loteamento"
}

export const SUBTIPONOME =
{
    Uniresidencial: "Uniresidencial",
    MultiresidencialAte4Pav: "Multiresidencial até 4 pavimentos",
    MultiresidencialAcima4Pav: "Multiresidencial acima de 4 pavimentos",
    NaoResidencial: "Não residencial",
    Loteamento: "Loteamento"
}

export const SUBTIPOFROMTIMPOIMOVEL =
{
    "Uniresidencial": "Uniresidencial",
    "Multiresidencial até 4 pavimentos": "MultiresidencialAte4Pav",
    "Multiresidencial acima de 4 pavimentos": "MultiresidencialAcima4Pav",
    "Não residencial / misto": "NaoResidencial",
    "Condomínio de lotes": "MultiresidencialAte4Pav",
    "ERB": "NaoResidencial",
    "GLP": "NaoResidencial",
    "Loteamento": "Loteamento"
}

function temSubtipo(tipoDoc)
{
    return tipoDoc === TIPO.Alvara || tipoDoc === TIPO.Anuencia || tipoDoc === TIPO.CertDemol || tipoDoc === TIPO.CertRegul || tipoDoc === TIPO.Habitese
}

export function ehValido(tipoDoc, subTipoDoc)
{
    // TODO remover isso e especificar os tipos de multa
    if (tipoDoc === "Multa") { return true }
    if (!Object.keys(TIPO).includes(tipoDoc)) { return false }
    if (temSubtipo(tipoDoc) && !Object.keys(SUBTIPO).includes(subTipoDoc)) { return false }
    if (!temSubtipo(tipoDoc) && !!subTipoDoc) { return false}

    return true
}